/**
 * As the name suggests, creates a <button> object that can be added to uScope's toolbar.
 * When styling using this method, you should set the background image manually using CSS.
 * NOTE The styling should include ".us_rootstyle" to ensure eSM rules don't override
 *      styling on hover.
 * @param className (string) - name of class to attach to button. Useful for attaching images
 * @param title (string) - alt-text that will appear when user hovers over the icon
 * @param onClick (function) - callback to execute when the user clicks the button
 */
export const createToolbarButton = ({className, title, onClick, context = null}) => {
  const button = document.createElement('button');
  button.className = `uscope-toolbar-button ${className}`;
  button.title = title;

  button.addEventListener('click', (e, ...args) => {
    onClick.apply(context, [e, ...args]);
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  });

  return button;
};



// WEBPACK FOOTER //
// ./src/uScope/js/components/toolbar-button/toolbar-button-factory.js